import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { APP_CONFIG_KEY } from '@/types/AppConfig.type';
import type { RootState } from '@/store/rootReducer';

import { resolveEnabledDisplayLocales } from './display-locales';
import type { AppLocale } from './locales';

export function useDisplayLanguagesEnabled(): boolean {
  return useSelector(
    (state: RootState) => state.appConfig[APP_CONFIG_KEY.enableDisplayLanguages] === true
  );
}

export function useEnabledDisplayLocales(): AppLocale[] {
  const translationsEnabled = useDisplayLanguagesEnabled();
  const configured = useSelector(
    (state: RootState) => state.appConfig[APP_CONFIG_KEY.displayLocales]
  );
  return useMemo(
    () => resolveEnabledDisplayLocales(translationsEnabled, configured),
    [translationsEnabled, configured]
  );
}
